export default {
  getZone: (state) => state.zone,
  getZones: (state) => state.zones,
  getDefaultZones: (state) => state.defaultZones,
  getCountryPhoneFormat: (state) => state.countryPhoneFormat,
  getCountries: (state) => state.countries,
};
